import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
    {
        heading: "Overview",
        paragraphs: [
            "This Privacy Policy explains what information SPCLIVE Studio (\"SPCLIVE\", \"we\", \"us\") collects, how we use it, and the choices you have. It applies to spclive.app and all related services.",
        ],
    },
    {
        heading: "Information We Collect",
        paragraphs: ["We collect only what we need to run the Service:"],
        bullets: [
            "Account data — email address, display name and a securely hashed password (never stored in plain text). If you sign in with Google, we receive your name, email and profile picture from Google;",
            "Billing data — credit purchases, transaction references and amounts. Card and bank details are processed entirely by Flutterwave; we never see or store your card number;",
            "Usage data — streaming session metadata (duration, credits consumed, timestamps) used for billing and platform statistics;",
            "Support data — tickets and messages you send to support;",
            "Technical data — authentication cookies required to keep you logged in.",
        ],
    },
    {
        heading: "Your Camera and Video",
        paragraphs: [
            "Your camera feed is processed in real time solely to generate the transformed output you requested. SPCLIVE does not record, store or archive your video streams. Video frames pass transiently through our AI infrastructure partner for live transformation and through encrypted peer-to-peer (WebRTC) connections to your own OBS output. Once your session ends, no video content remains on our servers.",
        ],
    },
    {
        heading: "How We Use Your Information",
        bullets: [
            "To operate the studio, meter credits and deliver your OBS output;",
            "To process payments and send purchase receipts by email;",
            "To respond to support tickets and notify you of replies;",
            "To prevent fraud, abuse and violations of our Terms of Use;",
            "To maintain platform statistics (aggregate, non-identifying).",
        ],
        paragraphs: [],
    },
    {
        heading: "What We Do NOT Do",
        bullets: [
            "We do not sell your personal data to anyone;",
            "We do not use your camera footage to train AI models;",
            "We do not send marketing emails without your consent;",
            "We do not share your data with third parties except the processors listed below.",
        ],
        paragraphs: [],
    },
    {
        heading: "Third-Party Processors",
        paragraphs: [
            "We share the minimum data necessary with: our AI infrastructure provider (transient video processing), Flutterwave (payment processing), our email delivery provider (transactional receipts and notifications), and Google (only if you choose Google sign-in). Each processor handles your data under its own privacy policy.",
        ],
    },
    {
        heading: "Cookies",
        paragraphs: [
            "We use strictly necessary cookies for authentication (keeping you signed in securely). We do not use advertising or cross-site tracking cookies.",
        ],
    },
    {
        heading: "Data Retention and Deletion",
        paragraphs: [
            "Account and billing records are kept while your account is active and as required for legal and accounting purposes. You may request deletion of your account and associated personal data by opening a support ticket; deletion is permanent and any remaining credits are forfeited.",
        ],
    },
    {
        heading: "Security",
        paragraphs: [
            "We protect your data with industry-standard measures: passwords are hashed, connections are encrypted (HTTPS/WSS), payment verification happens server-side, and private OBS links are unique per account and revocable. No system is 100% secure — keep your credentials and OBS link private.",
        ],
    },
    {
        heading: "Children",
        paragraphs: [
            "The Service is not directed at children and may not be used by anyone under 18. We do not knowingly collect data from minors; if we learn we have, we will delete it.",
        ],
    },
    {
        heading: "Changes to This Policy",
        paragraphs: [
            "We may update this Policy from time to time; the date above reflects the latest revision. Material changes will be reflected on this page.",
        ],
    },
    {
        heading: "Contact",
        paragraphs: [
            "For privacy questions or data requests, open a ticket from your console Support page.",
        ],
    },
];

export default function Privacy() {
    return <LegalPage pageTestId="privacy-page" title="Privacy Policy" updated="June 2026" sections={SECTIONS} />;
}
